<template lang="pug">
  .password-recovery-email-sent.mt-3
    v-container(fill-height)
      v-layout(
        row
        wrap
        fill-height
      )
        v-flex.py-0(
          xs12
        )
          h1 {{ $t('app.login.passwordRecoveryEmailSentComponent.title') }}
        v-flex.py-2(
          xs12
        )
          span.subtitle
            | {{ $t('app.login.passwordRecoveryEmailSentComponent.subtitle') }}
          b {{ email }}
        v-flex.py-0(
          xs8
          mx-auto
        )
          btn-primary(
            block
            @click="navigateTo('NewPassword')"
            :text="$t('app.login.passwordRecoveryEmailSentComponent.continue')"
          )
</template>

<script>
import BtnPrimary from 'Support/components/buttons/BtnPrimary.vue';
import BtnFlat from 'Support/components/buttons/BtnFlat.vue';
import PageableMixin from 'Support/components/lists/mixins/pageable.mixin';

export default {
  name: 'PasswordRecoveryEmailSent',
  components: {
    BtnPrimary,
    BtnFlat,
  },
  mixins: [PageableMixin],
  computed: {
    email() {
      const { query } = this.$route;
      if (query.email) {
        return query.email;
      }
      return '';
    },
  },
};
</script>

<style lang="stylus" scoped>
  .password-recovery-email-sent
    h1
      font-style normal
      font-weight bold
      font-size 36px
      line-height 39px
      color #113752
    .subtitle
      font-style normal
      font-weight normal
      font-size 14px
      color #113752
    .email-sent
      font-style normal
      font-weight bold
      font-size  14px
      color #113752
</style>
